/**
 * Resolve LiteAPI search center from plan stay area or city coords — mirrors iOS HotelSearchCenter.
 */

import type { Trip } from '../types/client';
import type { AggregatedPlanData } from './aggregatedPlanData';

export type HotelStayAreaSelection = 'recommended' | 'cityCenter';

export interface HotelSearchCenter {
  kind: 'recommended' | 'cityVisit';
  name: string;
  latitude: number;
  longitude: number;
  radiusKm: number;
}

export function resolveHotelSearchCenter(params: {
  selection: HotelStayAreaSelection;
  plan: AggregatedPlanData | null | undefined;
  trip: Trip;
  cityVisitId: string;
  cityName: string;
}): HotelSearchCenter | null {
  const stay = params.plan?.recommendedStayArea;
  const coords = params.trip.cityCoords?.[params.cityVisitId];

  if (params.selection === 'recommended' && stay) {
    const lat = stay.latitude;
    const lng = stay.longitude;
    if (
      typeof lat === 'number' &&
      typeof lng === 'number' &&
      Number.isFinite(lat) &&
      Number.isFinite(lng)
    ) {
      return {
        kind: 'recommended',
        name: stay.name || params.cityName,
        latitude: lat,
        longitude: lng,
        radiusKm: typeof stay.radiusKm === 'number' && stay.radiusKm > 0 ? stay.radiusKm : 3,
      };
    }
  }

  if (
    coords &&
    Number.isFinite(coords.latitude) &&
    Number.isFinite(coords.longitude) &&
    !(coords.latitude === 0 && coords.longitude === 0)
  ) {
    return {
      kind: 'cityVisit',
      name: params.cityName,
      latitude: coords.latitude,
      longitude: coords.longitude,
      radiusKm: 20,
    };
  }

  return null;
}

export function initialStayAreaSelection(
  plan: AggregatedPlanData | null | undefined
): HotelStayAreaSelection {
  const stay = plan?.recommendedStayArea;
  if (
    stay &&
    typeof stay.latitude === 'number' &&
    typeof stay.longitude === 'number'
  ) {
    return 'recommended';
  }
  return 'cityCenter';
}
